// extracted by mini-css-extract-plugin
export default {"errorMessage":"comments_errorMessage__3+Hyn","reviews":"comments_reviews__SaP02"};